import {getLang} from '../../../Localization';
import {Operator} from '../../../_legacy/Searches/consts/operators';
import {isHour12Format, formatTime} from '../utils/time';
import {ColumnType} from '../../../features/AppSearches/types/column';

export const replaceStars = (text: string) => {
    switch (text) {
        case '*': {
            return text;
        }
        case '**': {
            return '*';
        }
        case '***': {
            return '*';
        }
        default:
            return text.replace(/\*/g, '');
    }
};

export const serializeFilterValues = (operator: Operator, values: string[]) => {
    return operator === Operator.Contains
        ? values.map(val => `*${replaceStars(val)}*`)
        : operator === Operator.EndsWith
        ? values.map(val => `*${replaceStars(val)}`)
        : operator === Operator.StartsWith
        ? values.map(val => `${replaceStars(val)}*`)
        : operator === Operator.NotEmpty || operator === Operator.Empty
        ? ['']
        : values;
};
export const deSerializeFilterValues = (
    operator: Operator,
    values: string[],
    columnType: ColumnType
) => {
    const lang = getLang();

    if (columnType === ColumnType.Text) {
        switch (operator) {
            case Operator.Contains:
            case Operator.EndsWith:
            case Operator.StartsWith: {
                return values.map(val => replaceStars(val));
            }
            case Operator.NotEmpty:
            case Operator.Empty: {
                return [];
            }
            default: {
                return values;
            }
        }
    }
    if (columnType === ColumnType.Time) {
        return values.map(value => {
            const [hours, minutes] = value.split(':');
            return hours && minutes
                ? formatTime(Number(hours), Number(minutes), isHour12Format(lang))
                : value;
        });
    }
    return values;
};
